package ru.it_mozaika.sender.js.application.routes


import js.core.jso
import oldframes.campaigns.emailCampaignFrame
import oldframes.campaigns.emailCampaignsListStatisticsFrame
import react.Props
import react.create
import react.createElement

import react.router.RouteObject
import ru.it_mozaika.sender.js.application.components.campaigns.EmailCampaignFrame
import ru.it_mozaika.sender.js.application.components.campaigns.EmailCampaignListStatisticsFrame
import ru.it_mozaika.sender.js.application.frames.campaigns.CampaignsFrame


val campaignsRoutes = jso<RouteObject> {
    path = "campaigns"
    children = arrayOf(
        jso{
            path = ":campaignId"
            element = EmailCampaignFrame.create()
        } ,
        jso{
           path = "statistics"
            element = EmailCampaignListStatisticsFrame.create()
        },
        jso{
            path = ""
            index = true
            element = CampaignsFrame.create()
        }

    )

}